/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import {
    AccordionContent,
    AccordionHeading,
    AccordionItem,
    Button,
    Heading,
    Icon,
    Stack,
} from 'sarsaparilla';
import HolderForm from './HolderForm';
import type { FormError, Reservation } from '../../../types/permit';

interface HoldersTypes {
    errors: Record<string, Array<FormError>>;
    onChangeHandler: (key?: string, value?: string | boolean) => void;
    removeReservationHandler: (id: string, index: number) => void;
    reservations: Array<Reservation>;
}

export default function Holders({
    errors,
    onChangeHandler,
    removeReservationHandler,
    reservations,
}: HoldersTypes) {
    const hasReservations = !!reservations.length;

    return (
        hasReservations && (
            <div className="tp-holders">
                <Stack>
                    <Heading
                        headingLevel={3}
                        appearance="h5"
                        className="tp-holders-title"
                    >
                        Permit Holder Details
                    </Heading>
                    <div className="tp-holders-description">
                        <p>Please review your permit holder information.</p>
                    </div>
                    {reservations.map((item, index) => {
                        const id = item?.permit?.id;
                        const name = item?.permit?.name;

                        return (
                            <div className="tp-holders-accordion" key={id}>
                                <Button
                                    appearance="link"
                                    className="tp-holders-accordion-delete"
                                    onClick={() => removeReservationHandler(id, 0)}
                                    iconBeforeElement={<Icon iconName="delete" />}
                                    aria-label="Remove"
                                >
                                    <span className="tp-holders-accordion-delete-text">
                                        Remove
                                    </span>
                                </Button>
                                <AccordionItem
                                    id={`accordion-item-${id}`}
                                    isExpanded
                                    hasIndentedBody={false}
                                >
                                    <AccordionHeading
                                        className="tp-holders-accordion-heading"
                                        id={`accordion-item-heading-${id}`}
                                    >
                                        {name}
                                    </AccordionHeading>
                                    <AccordionContent
                                        className="tp-holders-accordion-content"
                                        id={`accordion-item-content-${id}`}
                                    >
                                        <HolderForm
                                            errors={errors[name] || []}
                                            index={index}
                                            onChangeHandler={onChangeHandler}
                                            reservation={item}
                                        />
                                    </AccordionContent>
                                </AccordionItem>
                            </div>
                        );
                    })}
                </Stack>
            </div>
        )
    );
}
